import * as Yup from "yup";
import { AbsenceCategory } from "../../../constants/absenceEnums";

export interface CreateAbsenceRequestFormValues {
  absenceCategory: AbsenceCategory | null;
  startDate: string | null;
  endDate: string | null;
  requestReason: string;
}

export const createAbsenceRequestValidationSchema = Yup.object({
  absenceCategory: Yup.number()
    .oneOf(
      [
        AbsenceCategory.Vacation,
        AbsenceCategory.SickDays,
        AbsenceCategory.MedicalLeave,
        AbsenceCategory.Maternity,
        AbsenceCategory.Parental,
        AbsenceCategory.FamilyHoliday,
        AbsenceCategory.EarlyLeave,
        AbsenceCategory.LateOnShift,
      ],
      "Invalid absence category"
    )
    .required("Absence category is required"),
  startDate: Yup.date()
    .required("Start date is required"),
  endDate: Yup.date()
    .required("End date is required")
    .test(
      "is-after-start",
      "End date must be on or after start date",
      function (value) {
        const { startDate } = this.parent;
        if (!startDate || !value) return true;
        return new Date(value) >= new Date(startDate);
      }
    ),
  requestReason: Yup.string()
    .required("Reason is required")
    .max(500, "Reason cannot exceed 500 characters"),
});



